// extracted by mini-css-extract-plugin
export default {"areadatosprospecto__subtitulo":"Subtitle_areadatosprospecto__subtitulo__GbetF","areadatosprospecto__subtitulo_info":"Subtitle_areadatosprospecto__subtitulo_info__kQmP3"};